/* eslint-disable */
import React, { useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import axios from "axios";
import Select from "react-select";
import config from "../../config/config";
import Button from "react-bootstrap/Button";

const { API_BASE_URL } = config;

const UserForm = ({ initialData, onSubmit, onCancel }) => {
  const token = useSelector((state) => state.auth.djangoAccessToken);

  const [entityOptions, setEntityOptions] = useState([]);
  const [levelOptions, setLevelOptions] = useState([]);
  const [categoriesOptions, setCategoriesOptions] = useState([]);
  const [subCategoriesOptions, setSubcategoriesOptions] = useState([]);
  const [pagesOptions, setPagesOptions] = useState([]);
  const [initaldatachcek, setinitaldatachcek] = useState(false);

  const [formData, setFormData] = useState({
    fname: "",
    lname: "",
    email: "",
    userName: "",
    entity: [],
    level: null,
    categories: [],
    subCategories: [],
    pages: [],
    is_active: true,
  });

  const authHeader = {
    // Authorization: `Bearer ${token}`,
    Authorization: 'Basic YWRtaW4xOjEyMw==',
  };

  const getOptions = () => {
    axios.get(`${API_BASE_URL}/api/entity-list`, { headers: authHeader })
      .then((res) => setEntityOptions(res.data))
      .catch(console.log);

    axios.get(`${API_BASE_URL}/api/level-list`, { headers: authHeader })
      .then((res) => setLevelOptions(res.data))
      .catch(console.log);


    axios.get(`${API_BASE_URL}/api/categories-list`, { headers: authHeader })
      .then((res) => {
        const options = res.data;
        setCategoriesOptions([{ label: "ALL", value: "__all__" }, ...options]);
      })
      .catch(console.log);
  };

  useEffect(() => {
    getOptions();
  }, []);

  useEffect(() => {
    if (
      initialData &&
      entityOptions.length > 0 &&
      levelOptions.length > 0 &&
      categoriesOptions.length > 0
    ) {
      const selectedEntity = entityOptions.filter((opt) =>
        initialData.entity?.includes(opt.value)
      );
      const selectedLevel = levelOptions.find((opt) => opt.value === initialData.level) || null;
      const selectedCategories = categoriesOptions.filter((opt) =>
        initialData.categories?.includes(opt.value)
      );

      setFormData((prev) => ({
        ...prev,
        userName: initialData.userName || "",
        fname: initialData.fname || "",
        lname: initialData.lname || "",
        email: initialData.email || "",
        entity: selectedEntity,
        level: selectedLevel,
        categories: selectedCategories,
        is_active: initialData.is_active !== undefined ? initialData.is_active : true,
      }));

      const selectedCategoryValues = selectedCategories.map((cat) => cat.value);
      axios
        .post(`${API_BASE_URL}/api/subCategories-list`, { categories: selectedCategoryValues }, { headers: authHeader })
        .then((res) => {
          const subCatOptions = [{ label: "ALL", value: "__all__" }, ...res.data];
          setSubcategoriesOptions(subCatOptions);

          const selectedSubCategories = subCatOptions.filter((opt) =>
            initialData.subCategories?.includes(opt.value)
          );

          setFormData((prev) => ({
            ...prev,
            subCategories: selectedSubCategories,
          }));

          const selectedSubCategoryValues = selectedSubCategories.map((sub) => sub.value);
          const selectedEntityValues = selectedEntity.map((ent) => ent.value);
          return axios.post(`${API_BASE_URL}/api/pages-list`, { subCategories: selectedSubCategoryValues, entity:selectedEntityValues }, { headers: authHeader });
        })
        .then((res) => {
          const pageOptions = [{ label: "ALL", value: "__all__" }, ...res.data];
          setPagesOptions(pageOptions);

          const selectedPages = pageOptions.filter((opt) =>
            initialData.pages?.includes(opt.value)
          );

          setFormData((prev) => ({
            ...prev,
            pages: selectedPages,
          }));
        })
        .catch(console.log);

      setinitaldatachcek(true);
    }
  }, [initialData, entityOptions, levelOptions, categoriesOptions]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCategoriesChange = (selectedOptions) => {
    if (selectedOptions === 'null' || selectedOptions === null){
      setFormData(prev => ({
        ...prev,
        subCategories: [],
        pages: []
      }));
    }
    const hasAll = selectedOptions?.some(opt => opt.value === "__all__");
    const finalSelected = hasAll
      ? categoriesOptions.filter(opt => opt.value !== "__all__")
      : selectedOptions || [];

    setFormData((prev) => ({
      ...prev,
      categories: finalSelected,
    }));

    if (finalSelected.length === 0) {
      setSubcategoriesOptions([]);
      return;
    }
    const selectedCategoryValues = finalSelected.map((opt) => opt.value);
    axios
      .post(
        `${API_BASE_URL}/api/subCategories-list`,
        { categories: selectedCategoryValues },
        { headers: authHeader }
      )
      .then((res) => {
        const options = [{ label: "ALL", value: "__all__" }, ...res.data];
        setSubcategoriesOptions(options);
      })
      .catch(console.log);
  };

  const handleSubCatChange = (selectedOptions) => {
    if (selectedOptions === 'null' || selectedOptions === null){
      setFormData(prev => ({
        ...prev,
        pages: []
      }));
    }
    const hasAll = selectedOptions?.some(opt => opt.value === "__all__");
    const finalSelected = hasAll
      ? subCategoriesOptions.filter(opt => opt.value !== "__all__")
      : selectedOptions || [];

    setFormData((prev) => ({
      ...prev,
      subCategories: finalSelected,
    }));

    if (finalSelected.length === 0) {
      setPagesOptions([]);
      return;
    }
    const selectedSubCategoryValues = finalSelected.map((opt) => opt.value);
    const selectedEntityValues = formData.entity.map((ent) => ent.value);
    axios
      .post(
        `${API_BASE_URL}/api/pages-list`,
        { subCategories: selectedSubCategoryValues, entities: selectedEntityValues  },
        { headers: authHeader }
      )
      .then((res) => {
        const options = [{ label: "ALL", value: "__all__" }, ...res.data];
        setPagesOptions(options);
      })
      .catch(console.log);
  };


  const handlePagesChange = (selectedOptions) => {
    const hasAll = selectedOptions?.some(opt => opt.value === "__all__");

    const finalSelected = hasAll
      ? pagesOptions.filter(opt => opt.value !== "__all__")
      : selectedOptions || [];

    setFormData((prev) => ({
      ...prev,
      pages: finalSelected,
    }));
  };

  // ############## new code 28072025 ################
  const handleSelectChange = (selected, actionMeta) => {
    setinitaldatachcek(false);
    const { name } = actionMeta;
    const multiWithAll = ["categories", "subCategories", "pages"];
    const isMultiWithAll = multiWithAll.includes(name);

    if (name === "entity" || name === "level") {
      setFormData((prev) => ({
        ...prev,
        [name]: selected || null,
      }));
      return;
    }

    const selectedArray = selected || [];

    if (isMultiWithAll) {
      const optionsMap = {
        categories: categoriesOptions,
        subCategories: subCategoriesOptions,
        pages: pagesOptions,
      };

      const hasAll = selectedArray.some((opt) => opt.value === "__all__");
      const allRealOptions = optionsMap[name].filter((opt) => opt.value !== "__all__");

      setFormData((prev) => ({
        ...prev,
        [name]: hasAll ? allRealOptions : selectedArray,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: selectedArray,
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const submissionData = {
      ...formData,
      entity: formData.entity?.map((ent) => ent.value) || [],
      level: formData.level?.value || "",
      categories: formData.categories?.map((cat) => cat.value) || [],
      subCategories: formData.subCategories?.map((cat) => cat.value) || [],
      pages: formData.pages?.map((cat) => cat.value) || [],
      is_update: !!initialData
    };
    // console.log("Form Data Submitted:", submissionData);
    if (onSubmit) onSubmit(submissionData);
  };

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      overflow: 'visible',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      overflowX: 'auto',
      whiteSpace: 'nowrap',
    }),
    option: (provided) => ({
      ...provided,
      padding: '8px 12px',
    }),
  };

  const customStylesMultiSelect = {
    control: (provided) => ({
      ...provided,
      minHeight: '40px',
      flexWrap: 'wrap',
    }),
    valueContainer: (provided) => ({
      ...provided,
      maxHeight: '100px',
      overflowY: 'auto',
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      overflow: 'visible',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      overflowX: 'auto',
      whiteSpace: 'nowrap',
    }),
    option: (provided) => ({
      ...provided,
      padding: '8px 12px',
    }),
  };


  return (
    <div className="max-w-md mx-auto mt-8 p-4 border rounded shadow">
      <div>
        <h4>{initialData ? "Edit User" : "Create New User"}</h4>
        <hr />
      </div>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="row p-2">
          <div className="col-lg-4 col-md-4 col-sm-6">
            <label className="font-weight-bold">User ID<span style={{color:"#f44336"}}>*</span></label>
            <input
              type="text"
              name="userName"
              value={formData.userName}
              onChange={handleChange}
              className="form-control"
              placeholder="Enter ID"
              required
              disabled={!!initialData}
            />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6">
            <label className="font-weight-bold">First Name<span style={{color:"#f44336"}}>*</span></label>
            <input
              type="text"
              name="fname"
              value={formData.fname}
              onChange={handleChange}
              className="form-control"
              placeholder="Enter first name"
              required
            />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6">
            <label className="font-weight-bold">Last Name<span style={{color:"#f44336"}}>*</span></label>
            <input
              type="text"
              name="lname"
              value={formData.lname}
              onChange={handleChange}
              className="form-control"
              placeholder="Enter last name"
              required
            />
          </div>
        </div>
        <div className="row p-2">
          <div className="col-lg-4 col-md-4 col-sm-6">
            <label className="font-weight-bold">Email<span style={{color:"#f44336"}}>*</span></label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="form-control"
              placeholder="Enter email"
              required
            />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6">
            <label className="font-weight-bold">Entity<span style={{color:"#f44336"}}>*</span></label>
            <Select
              name="entity"
              isMulti
              options={entityOptions}
              value={formData.entity}
              onChange={(selected) => handleSelectChange(selected, { name: "entity" })}
              placeholder="Select entity"
              closeMenuOnSelect={false}
              styles={customStyles}
            />
          </div>

          <div className="col-lg-4 col-md-4 col-sm-6">
            <label className="font-weight-bold">Level<span style={{color:"#f44336"}}>*</span></label>
            <Select
              name="level"
              options={levelOptions}
              value={formData.level}
              onChange={(selected) => handleSelectChange(selected, { name: "level" })}
              placeholder="Select level"
              styles={customStyles}
            />
          </div>
        </div>

        <div className="row p-2">
          <div className="col-lg-4 col-md-4 col-sm-6">
            <label className="font-weight-bold">Categories<span style={{color:"#f44336"}}>*</span></label>
            <Select
              name="categories"
              options={categoriesOptions}
              value={formData.categories}
              isMulti
              onChange={handleCategoriesChange}
              placeholder="Select categories"
              closeMenuOnSelect={false}
              styles={customStylesMultiSelect}
            />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6">
            <label className="font-weight-bold">Sub Categories<span style={{color:"#f44336"}}>*</span></label>
            <Select
              name="subCategories"
              options={subCategoriesOptions}
              value={formData.subCategories}
              isMulti
              onChange={handleSubCatChange}
              placeholder="Select subCategories"
              closeMenuOnSelect={false}
              styles={customStylesMultiSelect}
            />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6">
            <label className="font-weight-bold">Pages<span style={{color:"#f44336"}}>*</span></label>
            <Select
              name="pages"
              options={pagesOptions}
              value={formData.pages}
              isMulti
              onChange={handlePagesChange}
              placeholder="Select pages"
              closeMenuOnSelect={false}
              styles={customStylesMultiSelect}
            />
          </div>
        </div>
        <div className="row p-2">
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-check form-switch mt-2">
              <input
                type="checkbox"
                className="form-check-input"
                id="isActiveSwitch"
                name="is_active"
                checked={formData.is_active}
                onChange={(e) =>
                  setFormData({ ...formData, is_active: e.target.checked })
                }
                disabled={!!initialData}
              />
              <label className="form-check-label font-weight-bold" htmlFor="isActiveSwitch">
                Is Active
              </label>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-end pt-4 gap-4">
          <Button variant="secondary" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="success" type="submit">
            {initialData ? "Update" : "Submit"}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default UserForm;
